import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Receiptdata } from "../../assets/Griddata"; // Import dataset
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_09 } from "../../api/ApiModel";
import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";

function ViewReceiptDetails() {
  //------------------hooks-------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); // State to disable button
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const gotToPage = () => {
    navigate("/reciptdetail");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_09, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
        });
        setData(result);
        setIsLoading(false);

        // Disable the Add button if there are items in the result
        if (result.length >= 1) {
          setIsButtonDisabled(true); // Disable button
        }
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      RECEIPTDETCODE: item.RECEIPTDETCODE,
      HEADER: item.HEADER,
      FOOTER: item.FOOTER,
      REFPOLICY: item.REFPOLICY,
      TERMS: item.TERMS,
      RATE: currencyFormatLKR(item.RATE, "LKR", false),
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.HEADER.toLowerCase().includes(searchText.toLowerCase()) ||
          item.FOOTER.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  //--------------------functions------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.RECEIPTDETCODE === id);
      if (selectedItem) {
        navigate(`/reciptdetail`, { state: { selectedItem, actionText } });
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (RECEIPTDETCODE) => handleItemClick(RECEIPTDETCODE, "Edit"),
    },
  ];

  const rows = filteredData ? mapResultToRows(filteredData) : [];
  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">View Receipt Details</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                {!isButtonDisabled && (
                  <Button
                    onClick={() => gotToPage()}
                    variant="contained"
                    size="medium"
                    startIcon={<AddCircleIcon />}
                    sx={{
                      background: theme.palette.primary.main,
                      color: theme.palette.text.buttontxt,
                      textTransform: "capitalize",
                      letterSpacing: "2px",
                      width: "80px",
                    }}
                    disabled={isButtonDisabled} // Disable the button based on the state
                  >
                    Add
                  </Button>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <ViewData
        columns={Receiptdata.columns}
        rows={rows.map((item) => ({ ...item, id: item.RECEIPTDETCODE }))}
        menuItems={menuItems}
        tabletitle={Receiptdata.name}
        gridid="RECEIPTDETCODE"
      />
    </div>
  );
}

export default ViewReceiptDetails;
